import * as React from 'react';
import styled, { keyframes } from 'styled-components';

export const Spinner: React.FC = () => (
  <Loader>
    <div className='spinner'>
      <Circular viewBox='25 25 50 50'>
        <circle cx='50' cy='50' r='20' fill='none' />
      </Circular>
    </div>
  </Loader>
);

/* Loader */
const Rotate = keyframes`
100% {
  transform: rotate(360deg);
}
`;
const Dash = keyframes`
0% {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
}

50% {
  stroke-dasharray: 89, 200;
  stroke-dashoffset: -35px;
}

100% {
  stroke-dasharray: 89, 200;
  stroke-dashoffset: -124px;
}
`;

const Loader = styled.div`
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  width: 27px;
  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }
`;

const Circular = styled.svg`
  width: 100%;
  height: 100%;

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
  transform-origin: center center;
  animation: ${Rotate} 2s linear infinite;
  & circle {
    stroke-width: 4;
    stroke: #909090;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke-dasharray: 1, 200;
    animation: ${Dash} 1.5s ease-in-out infinite;
  }
`;
